export const useUtils = () => {
    const getOhcList = (listName) => {
        if (import.meta.client) {
            listName = swapListNames(listName);

            let ohcListString = localStorage.getItem(listName);
            let ohcList = JSON.parse(ohcListString) || [];

            let clone = JSON.parse(JSON.stringify(ohcList));
            return { ohcList, clone };
        }
    };

    const updateOhcList = (listName, list) => {
        listName = swapListNames(listName);

        const restringify = JSON.stringify(list);
        localStorage.setItem(listName, restringify);
    };

    const getSiteNeighborhoodName = (site, map) => {
        let name = null;
        let id = '';

        // Check if map exists
        if (!map) {
            return null;
        }

        if (site?.value || site?.fields) {
            if (site?.value?.fields?.['OHC Neighborhood']?.[0]) {
                id = site?.value?.fields?.['OHC Neighborhood']?.[0] || '';
            } else if (site?.fields?.['OHC Neighborhood']?.[0]) {
                id = site?.fields?.['OHC Neighborhood']?.[0] || '';
            }

            if (id && id.length && map[id]) {
                name = map[id]?.fields?.Name || null;
            }
        }

        return name;
    };

    return {
        getOhcList,
        updateOhcList,
        getSiteNeighborhoodName,
    };
};

const swapListNames = (listName) => {
    const CURRENT_YEAR = 2025;
    let list = false;
    switch (listName) {
        case 'ohcFavoriteEvents':
            list = 'events';
            break;
        case 'ohcFavoriteSites':
            list = 'sites';
            break;
        case 'ohcFavoriteTours':
            list = 'tours';
            break;
        case 'ohcItineraries':
            list = 'itineraries';
            break;
        case 'readNotifications':
            list = 'readNotifications';
            break;
        case 'hasVisitedBefore':
            list = 'hasVisitedBefore';
            break;
        default:
            console.error('Invalid list name: ' + listName);
            break;
    }
    if (list) {
        list = list + CURRENT_YEAR;
    }
    return list;
};
